import useTranslation from 'next-translate/useTranslation';

export default function SubmitButton({
  isSubmitting,
}: {
  isSubmitting: boolean;
}) {
  const { t } = useTranslation('products');
  return (
    <button
      type='submit'
      className='mx-auto mb-12 mt-4 rounded bg-brand-500 px-28 py-4 text-center uppercase text-white hover:bg-brand-400'
      disabled={isSubmitting}
    >
      {t('DETAIL_MODALQUOTE_BTN_SEND')}
    </button>
  );
}
